import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "main" }
const _hoisted_2 = { class: "index-hero" }
const _hoisted_3 = { id: "heroSlider" }
const _hoisted_4 = { class: "slider-img" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "index-info" }
const _hoisted_9 = { class: "container-lg" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-6 col-xl-5 article-left" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h1", null, "關於 HYS 新創竹夢資源網", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "h4 my-4" }, "新竹縣政府為創業家們打造的創新創業資源的整合平台，此平台提供一站式服務，包含彙整縣府各局處及中央的創業資源及相關訊習，可協助新創快速了解各種創業政策、資金募集及重要創業活動等，更輕鬆取得有關創業的各類信息，為創業者們節省寶貴的時間與精力。更能透過創業診斷釐清目前的創業階段，並提供創業的諮詢服務，期能為正在創業的青年夢想家注入更多的動力與支援，在竹縣搭建出最堅實的創業基石，「竹」夢成金。", -1)
const _hoisted_14 = { class: "frce justify-content-md-start" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "了解更多", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 col-xl-6 offset-lg-1 article-right info-illus" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "img-fluid",
    src: "resources/images/illustration/info1.svg",
    alt: ""
  })
], -1)
const _hoisted_17 = { class: "index-startup bg-primary" }
const _hoisted_18 = { class: "container-lg" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "row head-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "resources/images/illustration/startup-head.svg",
      alt: ""
    })
  ])
], -1)
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-10 mx-auto" }
const _hoisted_22 = { class: "d-grid startup-group" }
const _hoisted_23 = { class: "startup-card" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "fcss card-text" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "h2 mb-1" }, "近期活動"),
  /*#__PURE__*/_createElementVNode("small", null, "Recent events")
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "card-icon flex-shrink-0 fccc" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon-startup1" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      width: "25",
      height: "25",
      viewBox: "0 0 25 25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M20.347 0c2.476 0 4.483 1.944 4.483 4.343v15.368c0 2.399-2.007 4.343-4.483 4.343H4.483C2.007 24.054 0 22.11 0 19.711V4.343C0 1.944 2.007 0 4.483 0h15.864zm2.414 7.35H2.069V19.71c0 1.292 1.081 2.339 2.414 2.339h15.864c1.333 0 2.414-1.047 2.414-2.339V7.35zM6.552 15.368c.953 0 1.725.748 1.725 1.67 0 .923-.772 1.67-1.725 1.67-.952 0-1.724-.747-1.724-1.67 0-.922.772-1.67 1.724-1.67zm5.863 0c.952 0 1.724.748 1.724 1.67 0 .923-.772 1.67-1.724 1.67s-1.724-.747-1.724-1.67c0-.922.772-1.67 1.724-1.67zm-5.863-5.345c.953 0 1.725.747 1.725 1.67 0 .923-.772 1.67-1.725 1.67-.952 0-1.724-.747-1.724-1.67 0-.923.772-1.67 1.724-1.67zm5.863 0c.952 0 1.724.747 1.724 1.67 0 .923-.772 1.67-1.724 1.67s-1.724-.747-1.724-1.67c0-.923.772-1.67 1.724-1.67zm5.863 0c.952 0 1.724.747 1.724 1.67 0 .923-.772 1.67-1.724 1.67-.953 0-1.725-.747-1.725-1.67 0-.923.772-1.67 1.725-1.67zm2.069-8.018H4.483c-1.333 0-2.414 1.047-2.414 2.338v1.002h20.692V4.343c0-1.291-1.081-2.338-2.414-2.338z",
        fill: "#545DBF"
      })
    ])
  ])
], -1)
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<div class=\"startup-card\"><a href=\"https://exam.taiwanjobs.gov.tw/JobExam/\" title=\"創業診斷\" class=\"fcss\" target=\"_blank\"><div class=\"fcss card-text\"><h2 class=\"mb-1\">創業診斷</h2><small>Startup diagnosis</small></div><div class=\"card-icon flex-shrink-0 fccc\"><div class=\"icon-startup2\"><svg width=\"27\" height=\"27\" viewBox=\"0 0 27 27\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15.8625 0C17.4265 0 18.7142 1.1819 18.8816 2.70123L18.8814 2.69924L21.2625 2.7C22.94 2.7 24.3 4.05994 24.3 5.7375V14.85H22.275V5.7375C22.275 5.17832 21.8217 4.725 21.2625 4.725L18.3884 4.72527C17.8434 5.53919 16.9155 6.075 15.8625 6.075H11.1375C10.0845 6.075 9.15656 5.53914 8.61165 4.72522L5.7375 4.725C5.17832 4.725 4.725 5.17832 4.725 5.7375V14.85H2.7V5.7375C2.7 4.05994 4.05994 2.7 5.7375 2.7L8.11862 2.69924C8.28685 1.18087 9.57427 0 11.1375 0H15.8625ZM18.893 2.82953L18.9 3.0375C18.9 2.9676 18.8977 2.89825 18.893 2.82953ZM15.8625 2.025H11.1375C10.5783 2.025 10.125 2.47832 10.125 3.0375C10.125 3.59668 10.5783 4.05 11.1375 4.05H15.8625C16.4217 4.05 16.875 3.59668 16.875 3.0375C16.875 2.47832 16.4217 2.025 15.8625 2.025ZM22.275 19.575H24.3V23.9625C24.3 25.64 22.94 27 21.2625 27H5.7375C4.05994 27 2.7 25.64 2.7 23.9625V19.575H4.725V23.9625C4.725 24.5217 5.17832 24.975 5.7375 24.975H21.2625C21.8217 24.975 22.275 24.5217 22.275 23.9625V19.575ZM12.1088 8.82676C11.9915 8.42756 11.6417 8.14085 11.2273 8.10394C10.8128 8.06705 10.418 8.28747 10.2319 8.65966L6.46173 16.2H1.0125C0.453317 16.2 0 16.6533 0 17.2125C0 17.7717 0.453317 18.225 1.0125 18.225H7.0875C7.47101 18.225 7.8216 18.0083 7.99311 17.6653L10.8922 11.8669L13.5412 20.8732C13.6585 21.2724 14.0083 21.5591 14.4227 21.5959C14.8372 21.6328 15.2321 21.4125 15.4181 21.0403L17.9682 15.94L19.0443 17.7333C19.2272 18.0383 19.5569 18.225 19.9125 18.225H25.9875C26.5467 18.225 27 17.7717 27 17.2125C27 16.6533 26.5467 16.2 25.9875 16.2H20.4857L18.7557 13.3165C18.5656 12.9997 18.218 12.8115 17.8486 12.8257C17.4794 12.8398 17.1472 13.0541 16.9819 13.3847L14.7578 17.833L12.1088 8.82676Z\" fill=\"#545DBF\"></path></svg></div></div></a></div>", 1)
const _hoisted_27 = { class: "startup-card" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "fcss card-text" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "h2 mb-1" }, "政府資源總覽"),
  /*#__PURE__*/_createElementVNode("small", null, "Government resources")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "card-icon flex-shrink-0 fccc" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon-startup3" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      width: "27",
      height: "24",
      viewBox: "0 0 27 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M4.82143 0C2.86871 0 1.28571 1.583 1.28571 3.53571V9.33069C1.85954 8.85677 2.50942 8.47157 3.21429 8.1963V3.53571C3.21429 2.64811 3.93382 1.92857 4.82143 1.92857H23.4643C24.3519 1.92857 25.0714 2.64811 25.0714 3.53571V17.0357C25.0714 17.9234 24.3519 18.6429 23.4643 18.6429H12.8249L14.7534 20.5714H23.4643C25.417 20.5714 27 18.9885 27 17.0357V3.53571C27 1.583 25.417 0 23.4643 0H4.82143ZM9.85253 9C10.5886 9.51827 11.2212 10.1735 11.7135 10.9286H20.8929C21.4254 10.9286 21.8571 10.4968 21.8571 9.96429C21.8571 9.43174 21.4254 9 20.8929 9H9.85253ZM18.3214 14.7857H12.8571C12.8571 14.1171 12.7643 13.4702 12.591 12.8571H18.3214C18.854 12.8571 19.2857 13.2889 19.2857 13.8214C19.2857 14.354 18.854 14.7857 18.3214 14.7857ZM7.39286 5.14286C6.8603 5.14286 6.42857 5.57459 6.42857 6.10714C6.42857 6.6397 6.8603 7.07143 7.39286 7.07143H15.75C16.2825 7.07143 16.7143 6.6397 16.7143 6.10714C16.7143 5.57459 16.2825 5.14286 15.75 5.14286H7.39286ZM5.78571 20.5714C7.03526 20.5714 8.1923 20.1753 9.13809 19.5018L12.4968 22.8604C12.8733 23.237 13.4838 23.237 13.8604 22.8604C14.237 22.4838 14.237 21.8733 13.8604 21.4968L10.5018 18.1381C11.1753 17.1923 11.5714 16.0353 11.5714 14.7857C11.5714 11.5903 8.98107 9 5.78571 9C2.59035 9 0 11.5903 0 14.7857C0 17.9811 2.59035 20.5714 5.78571 20.5714ZM5.78571 18.6429C3.65548 18.6429 1.92857 16.916 1.92857 14.7857C1.92857 12.6554 3.65548 10.9286 5.78571 10.9286C7.91595 10.9286 9.64286 12.6554 9.64286 14.7857C9.64286 16.916 7.91595 18.6429 5.78571 18.6429Z",
        fill: "#545DBF"
      })
    ])
  ])
], -1)
const _hoisted_30 = { class: "startup-card" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "fcss card-text" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "h2 mb-1" }, "資金快搜"),
  /*#__PURE__*/_createElementVNode("small", null, "Funding search")
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "card-icon flex-shrink-0 fccc" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon-startup4" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      width: "25",
      height: "25",
      viewBox: "0 0 25 25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M10.0695 0C15.6307 0 20.1389 4.50826 20.1389 10.0695C20.1389 12.4749 19.2954 14.6832 17.8882 16.415L24.6949 23.2218C25.1017 23.6286 25.1017 24.2881 24.6949 24.6949C24.3252 25.0648 23.7464 25.0984 23.3386 24.7957L23.2218 24.6949L16.415 17.8882C14.6832 19.2954 12.4749 20.1389 10.0695 20.1389C4.50826 20.1389 0 15.6307 0 10.0695C0 4.50826 4.50826 0 10.0695 0ZM10.0695 2.08334C5.65884 2.08334 2.08334 5.65884 2.08334 10.0695C2.08334 14.48 5.65884 18.0556 10.0695 18.0556C14.48 18.0556 18.0556 14.48 18.0556 10.0695C18.0556 5.65884 14.48 2.08334 10.0695 2.08334Z",
        fill: "#545DBF"
      })
    ])
  ])
], -1)
const _hoisted_33 = { class: "startup-card" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "fcss card-text" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "h2 mb-1" }, "AIoT 加速器"),
  /*#__PURE__*/_createElementVNode("small", null, "AIoT accelerator")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "card-icon flex-shrink-0 fccc" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon-startup5" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      width: "24",
      height: "29",
      viewBox: "0 0 24 29",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M2.30085 13.0914C4.26667 3.79285 9.427 1.77124 12.0133 1.77124C13.8154 1.77124 15.7573 2.47043 17.5285 4.38763C19.1083 6.09766 20.5721 8.80109 21.6298 12.8842L19.665 14.6704L16.8391 12.062C16.2768 11.5429 15.4099 11.5429 14.8476 12.062L12.0263 14.6663L9.22129 12.077C8.64228 11.5425 7.74459 11.5605 7.1874 12.1177L4.36024 14.9448L2.30085 13.0914ZM1.94429 15.1406C1.44435 19.1265 2.60665 21.9406 4.48602 23.7886C6.48915 25.7584 9.40815 26.729 12.3193 26.729C18.655 26.729 23.1506 20.7199 22.082 14.854L20.651 16.1549C20.0879 16.6669 19.2269 16.6636 18.6677 16.1474L15.8434 13.5404L13.0221 16.1446C12.4597 16.6637 11.5929 16.6637 11.0305 16.1446L8.23364 13.5629L5.40899 16.3875C4.85686 16.9397 3.96916 16.963 3.38878 16.4407L1.94429 15.1406ZM12.0133 0.00952148C8.24425 0.00952148 2.11221 3.06629 0.292285 14.2555C-0.487756 19.0513 0.819178 22.6537 3.2508 25.0448C5.65197 27.4059 9.05199 28.4907 12.3193 28.4907C19.9534 28.4907 25.2294 21.1821 23.7513 14.2141C22.6416 8.98266 20.899 5.43976 18.8225 3.19214C16.7282 0.925243 14.3219 0.00952148 12.0133 0.00952148Z",
        fill: "#545DBF"
      })
    ])
  ])
], -1)
const _hoisted_36 = { class: "startup-card" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "fcss card-text" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "h2 mb-1" }, "青創基地"),
  /*#__PURE__*/_createElementVNode("small", null, "Startup hub")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "card-icon flex-shrink-0 fccc" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon-startup6" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      width: "24",
      height: "28",
      viewBox: "0 0 24 28",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M3.503 3.503C8.17366 -1.16767 15.7464 -1.16767 20.417 3.503C25.0877 8.17366 25.0877 15.7464 20.417 20.417L18.7866 22.0294C17.5849 23.2088 16.0257 24.7252 14.1084 26.5788C12.9104 27.7373 11.0096 27.7371 9.81177 26.5785L5.01648 21.9141C4.41382 21.3223 3.90935 20.8233 3.503 20.417C-1.16767 15.7464 -1.16767 8.17366 3.503 3.503ZM18.9601 4.95988C15.0941 1.09382 8.82592 1.09382 4.95988 4.95988C1.09382 8.82592 1.09382 15.0941 4.95988 18.9601L7.00245 20.9758C8.12728 22.0765 9.54131 23.4507 11.2441 25.0976C11.6434 25.4837 12.2769 25.4838 12.6763 25.0977L17.3394 20.5629C17.9835 19.9306 18.5238 19.3963 18.9601 18.9601C22.8261 15.0941 22.8261 8.82592 18.9601 4.95988ZM11.96 8.2152C14.237 8.2152 16.0828 10.061 16.0828 12.338C16.0828 14.615 14.237 16.4608 11.96 16.4608C9.68306 16.4608 7.83718 14.615 7.83718 12.338C7.83718 10.061 9.68306 8.2152 11.96 8.2152ZM11.96 10.2755C10.8209 10.2755 9.89748 11.1989 9.89748 12.338C9.89748 13.4771 10.8209 14.4004 11.96 14.4004C13.0991 14.4004 14.0224 13.4771 14.0224 12.338C14.0224 11.1989 13.0991 10.2755 11.96 10.2755Z",
        fill: "#545DBF"
      })
    ])
  ])
], -1)
const _hoisted_39 = { class: "index-service" }
const _hoisted_40 = { class: "container-lg" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 mb-4 mb-md-0 article-left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "img-fluid mt-md-4 pt-md-3",
    src: "resources/images/illustration/sercive1.png",
    alt: ""
  })
], -1)
const _hoisted_43 = { class: "col-md-6 col-lg-5 offset-lg-1 article-right" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "h1" }, "資金快搜", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", { class: "h4 my-4" }, "創業最需要資金，統整中央政府與新竹的貸款、研發補助、創投資金等。新創竹夢資源網提供各種政府的資金資訊，協助創業家找到資源的挹注，可繼續堅持往夢想邁進。", -1)
const _hoisted_46 = { class: "frce justify-content-md-start" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", null, "了解更多", -1)
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-md-6 col-lg-5 order-md-0 order-1 article-left" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "h1" }, "AIoT 加速器", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("p", { class: "h4 my-4" }, "新竹AIoT加速器是StarFab與新竹縣政府攜手合作的【青年創新創業培育計畫】，共同為大新竹地區量身打造的AIoT為主題之定向育成加速器，透過鏈結大新竹地區的企業，包含拓緯實業、智邦科技、華夏玻璃、緯謙科技、邁特電子、聯達智能、醫智亮加速器等企業擔任企業導師，邀請全台具備創新技術的青年創業家進行提案構想與審核，透過「以大(企業)帶小(新創)」的機制從中媒合具備潛力之青創與企業合作，在企業導師與創業輔導師的雙軌協助下，串連各方資源扶植青創快速掌握市場端的需求，並透過技術支援、場域驗證、行銷通路等多面向合作，深度結合雙方優勢、搶攻科技新商機。", -1)
const _hoisted_52 = { class: "frce justify-content-md-start" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", null, "了解更多", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 col-lg-5 offset-lg-1 align-self-center mb-4 mb-md-0 article-right" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "img-fluid",
    src: "resources/images/illustration/sercive2.png",
    alt: ""
  })
], -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("article", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 col-lg-5 mb-4 mb-md-0 article-left" }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "img-fluid",
        src: "resources/images/illustration/sercive3.png",
        alt: ""
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 col-lg-5 offset-lg-2 article-right" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "h1" }, "創業診斷"),
      /*#__PURE__*/_createElementVNode("p", { class: "h4 my-4" }, "正在創業的您，正苦於事業經營碰到難題，卻不知道要如何調整，產品、資金、市場拓展等都需要協助時，要如何找到適合現階段的資源，適時調整步伐讓自己盡快步入軌道。新竹縣府為了各位創業家，提供初步的創業現況診斷，透過一系列的引導，推薦給您適合的資源與諮詢管道，讓身處於創業的您找到快速找到問題。歡迎透過線上診斷，由我們來協助各位喔!"),
      /*#__PURE__*/_createElementVNode("div", { class: "frce justify-content-md-start" }, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "https://exam.taiwanjobs.gov.tw/JobExam/",
          class: "btn-anchor",
          title: "了解更多",
          aria: "了解更多",
          target: "_blank"
        }, [
          /*#__PURE__*/_createElementVNode("span", null, "了解更多")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_56 = { class: "index-event bg-primary" }
const _hoisted_57 = { class: "container-lg" }
const _hoisted_58 = { class: "row head-row" }
const _hoisted_59 = { class: "col-md-10 mx-auto frcb justify-content-md-start" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "h1 me-5 text-white" }, "近期活動", -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", null, "了解更多", -1)
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "col-md-10 mx-auto event-group" }
const _hoisted_64 = { class: "h4 flex-grow-1" }
const _hoisted_65 = /*#__PURE__*/_createStaticVNode("<section class=\"index-unit\"><div class=\"container-lg\"><div class=\"row\"><div class=\"col-md-8 mx-auto\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"unit-group mb-4\"><div class=\"head mb-2\">指導單位</div><div class=\"unit-item mb-md-2 mb-3\"><img class=\"img-fluid\" src=\"resources/images/logo/logo-unit01@2x.png\" alt=\"勞動部勞動力發展署\"></div><div class=\"unit-item mb-md-2 mb-3\"><img class=\"img-fluid\" src=\"resources/images/logo/logo-unit02@2x.png\" alt=\"新竹縣政府\"></div><div class=\"unit-item mb-md-2 mb-3\"><img class=\"img-fluid\" src=\"resources/images/logo/logo-unit03@2x.png\" alt=\"新竹縣議會\"></div></div></div><div class=\"col-md-6\"><div class=\"unit-group mb-4\"><div class=\"head mb-2\">主辦單位</div><div class=\"unit-item mb-2\"><img class=\"img-fluid\" src=\"resources/images/logo/logo-unit04@2x.png\" alt=\"新竹縣政府教育局\"></div></div><div class=\"unit-group mb-4\"><div class=\"head mb-2\">執行單位</div><div class=\"unit-item mb-2\"><img class=\"img-fluid\" src=\"resources/images/logo/logo-unit05@2x.png\" alt=\"StarFab\"></div></div></div></div></div></div></div></section>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_date = _resolveComponent("date")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.banners, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "slider-item",
            key: item.id
          }, [
            _createElementVNode("div", _hoisted_4, [
              (item.url)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: item.url,
                    title: "另開新視窗",
                    target: "_blank"
                  }, [
                    (item.url)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: item.file.path,
                          alt: item.name
                        }, null, 8, _hoisted_6))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_5))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: item.file.path,
                    alt: item.name
                  }, null, 8, _hoisted_7))
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("article", null, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_router_link, {
                  to: "/resources",
                  class: "btn-anchor",
                  title: "了解更多",
                  aria: "了解更多"
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                })
              ])
            ]),
            _hoisted_16
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_router_link, {
                  to: "/events",
                  title: "近期活動",
                  class: "fcss"
                }, {
                  default: _withCtx(() => [
                    _hoisted_24,
                    _hoisted_25
                  ]),
                  _: 1
                })
              ]),
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_router_link, {
                  to: "resources",
                  title: "政府資源總覽",
                  class: "fcss"
                }, {
                  default: _withCtx(() => [
                    _hoisted_28,
                    _hoisted_29
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_router_link, {
                  to: "/funds",
                  title: "資金快搜",
                  class: "fcss"
                }, {
                  default: _withCtx(() => [
                    _hoisted_31,
                    _hoisted_32
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_router_link, {
                  to: "/aiot_accelerator",
                  title: "AIoT 加速器",
                  class: "fcss"
                }, {
                  default: _withCtx(() => [
                    _hoisted_34,
                    _hoisted_35
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createVNode(_component_router_link, {
                  to: "/startup",
                  title: "青創基地",
                  class: "fcss"
                }, {
                  default: _withCtx(() => [
                    _hoisted_37,
                    _hoisted_38
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("article", null, [
          _createElementVNode("div", _hoisted_41, [
            _hoisted_42,
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              _hoisted_45,
              _createElementVNode("div", _hoisted_46, [
                _createVNode(_component_router_link, {
                  to: "/funds",
                  class: "btn-anchor",
                  title: "了解更多",
                  aria: "了解更多"
                }, {
                  default: _withCtx(() => [
                    _hoisted_47
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("article", null, [
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _hoisted_50,
              _hoisted_51,
              _createElementVNode("div", _hoisted_52, [
                _createVNode(_component_router_link, {
                  to: "/aiot_accelerator",
                  class: "btn-anchor",
                  title: "了解更多",
                  aria: "了解更多"
                }, {
                  default: _withCtx(() => [
                    _hoisted_53
                  ]),
                  _: 1
                })
              ])
            ]),
            _hoisted_54
          ])
        ]),
        _hoisted_55
      ])
    ]),
    _createElementVNode("section", _hoisted_56, [
      _createElementVNode("div", _hoisted_57, [
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("div", _hoisted_59, [
            _hoisted_60,
            _createVNode(_component_router_link, {
              to: "/events",
              class: "btn-anchor text-white",
              title: "了解更多",
              aria: "了解更多"
            }, {
              default: _withCtx(() => [
                _hoisted_61
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("div", _hoisted_63, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.news.content, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: "event-card mb-md-4 mb-2 mx-md-auto"
              }, [
                _createVNode(_component_router_link, {
                  to: {name: 'events-detail', params: { id: item.id }},
                  title: "近期活動",
                  class: "fcss flex-md-row align-items-md-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_date, { class: "me-md-4 flex-shrink-0" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.date), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("div", _hoisted_64, _toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _hoisted_65
  ]))
}